module.exports = __webpack_public_path__ + "img/cool.4c29f612.gif";